// The one place the anonymized wire value is spelled: the chip fails open to neutral whatever the
// string turns out to be, but the «Dar de baja» button must not be offered on an anonymized
// account, and that gate needs the exact value. Pending backend confirmation of the canonical
// spelling — if it differs, this constant is the only edit.
//
// It lives in the app's own `lib/` and not in a slice, next to `firstActiveRecipient`, because what
// it spells is a value of the WIRE and not a rule of the «Usuario» screen: the «Entrega» detail
// reads it too, to tell the agent WHY an account cannot become the titular. Keeping it inside
// `user-card` would have meant either a second cross-slice edge or a second copy of the spelling —
// and a second copy is precisely what the promise above rules out.
export const ANONYMIZED_STATUS = 'anonimizado';
export const isAnonymized = (status: string): boolean =>
  status.trim().toLowerCase() === ANONYMIZED_STATUS;
